module.exports = __webpack_public_path__ + "img/12_2.6fe54967.png";